<template>
  <div id="wrapper">
    <div id="manage-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_manage_on_2.png" alt="">
          <span>{{$t('userInputDataManageStr')}}</span>
        </h1>
        <span class="info-right">
          <b-btn variant="primary" @click="$router.replace({ name: 'ManageUserSearch' })">{{$t('returnStr')}}</b-btn>
        </span>
      </div>
      <!-- /ViewTitleBox -->
      <manage-wrapper-component require-admin>
      <!-- MainView -->
        <article  :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
          <section class="animated fadeInRight">
            <!-- profileItem -->
            <div class="ibox">
              <div class="ibox-title">
                <div class="ibox-tools">
                  <span class="info-menu">
                    <!-- プロフィール -->
                    {{ $t("viewName.profile") }}
                  </span>
                  <span class="info-right">
                    <button @click="onClickDeleteButton" type="button" class="btn btn-danger block m-b">{{ $t('deleteStr') }}</button>
                  </span>
                </div>
              </div>
              <!-- UserElement -->
              <div class="ibox-child">
                <div class="flex-box">
                  <span class="info-profimg">
                    <img v-if="getTargetUserInfo.userIcon" :src="getTargetUserInfo.userIcon" :alt="getTargetUserInfo.userName" class="img-circle">
                    <img v-else :src="'static/img/noImage.png'" alt="noImage" class="img-circle">
                  </span>
                  <div class="profile-box">
                    <div class="info-profelement ibox-child row">
                      <label class="col-md-4">{{$t('profileUserTitle')}}</label>
                      <div class="col-md-8">
                        <span>{{ getTargetUserInfo.userName }}</span>
                      </div>
                    </div>
                    <div class="info-profelement ibox-child row">
                      <label class="col-md-4">{{$t('departmentStr')}}</label>
                      <div class="col-md-8">
                        <span> {{ getTargetUserInfo.dept }}</span>
                      </div>
                    </div>
                  </div>
                  <span class="info-statusimg dropdown" v-if="!willysmEnabled">
                    <img v-if="getTargetUserInfo.userFeeling == 'sunny'" alt="sunny" class="img-circle" src="static/img/assets/status_01.png">
                    <img v-else-if="getTargetUserInfo.userFeeling == 'rainy'"  alt="rainy" class="img-circle" src="static/img/assets/status_03.png">
                    <img v-else alt="cloudy" class="img-circle" src="static/img/assets/status_02.png">
                  </span>
                </div>
              </div>
              <!-- /UserElement -->
              <!-- Comment -->
              <div class="ibox-child">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div :style="{display: 'flex'}">
                      <label class="control-label">{{$t('profileBioTitle')}}</label>
                    </div>
                    <span class="prof-item">{{ getTargetUserInfo.userBio }}</span>
                  </div>
                </div>
              </div>
              <!-- /Comment -->

              <!-- Mail -->
              <div class="ibox-child">
                <div class="row">
                  <div id="limited" class="date form-group col-sm-3">
                    <label class="control-label">{{$t('profileMailTitle')}}</label>
                  </div>
                  <div class="form-group col-sm-9">
                    <div class="input-group">
                      <span><a :href='"mailto:" + getTargetUserInfo.userEmail'>{{ getTargetUserInfo.userEmail }}</a></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Mail -->
              <!-- Tel -->
              <div class="ibox-child">
                <div class="row">
                  <div id="limited" class="date form-group col-sm-3">
                    <label class="control-label">{{$t('profilePhoneTitle')}}</label>
                  </div>
                  <div class="form-group col-sm-9">
                    <div class="input-group">
                      <span><a :href='"tel:" + getTargetUserInfo.userPhone'>{{ getTargetUserInfo.userPhone }}</a></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Tel -->

              <!-- Carrer -->
              <div class="ibox-child">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div :style="{display: 'flex'}">
                      <label class="control-label">{{$t('profileSummarayTitle')}}</label>
                    </div>
                    <span class="prof-item">
                      <read-more :targetId="'carrer'" :text="getTargetUserInfo.careerSummary" v-if="getTargetUserInfo.careerSummary" :addMore="true" :detailView="false" :showMore="this.carrerShowMore" :contentHeight="this.carrerContentHeight" @update-show-more="updateCarrerShowMore" @update-content-height="updateCarrerContentHeight">
                        <span class="prof-item">
                          {{ getTargetUserInfo.careerSummary }}
                        </span>
                      </read-more>
                    </span>
                  </div>
                </div>
              </div>
              <!-- /Carrer -->
              <manage-other-items v-if="$route.params.userId !== 'profile'" :userId="this.userId" v-on:set-target="setTarget"/>
            </div>
            <!-- /profileItem -->

          </section>
        </article>

        <!-- テスト確認用 -->
        <!-- DetailView -->
        <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
          <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
          <article class="sub-content-wrap">
            <section class="inner-wrap">
              <!--<span v-if="clickedCommentId.length > 0">{[ this.getUserInfoById(this.targetComment.userId).userName }}</span>-->
              <div class="s-inner-wrap">
                <div class="ibox-title flex-box fl-between ibox-detail-header">
                  <template v-if="manageInfo != null">
                    <b-container>
                      <router-link :to="{ name: 'User', params: { userId: commentTarget, item: getCommentTargetItem() }}">
                        <b-row>
                          <b-col cols="2">
                            <span class="info-userimg" v-if="manageInfo != null">
                              <img v-if="manageInfo.userIcon" alt="image" class="img-circle" :src="manageInfo.userIcon">
                              <img v-else alt="image" class="img-circle" :src="'static/img/noImage.png'">
                            </span>
                          </b-col>
                          <b-col cols="8">
                            <div v-if="manageInfo != null">{{ manageInfo.userName }}</div>
                            <span v-if="manageInfo != null" style="color: black;">{{ getTargetTypeString }}</span>
                          </b-col>
                        <!-- <b-col cols="2">
                          <button @click="onClickDeleteItem('userName')" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                        </b-col> -->
                        </b-row>
                      </router-link>
                    </b-container>
                  </template>
                  <template v-else-if="targetType === 'objectives' || targetType === 'keyresults'">
                    <span class="info-menu">
                      <template v-if="targetType === 'objectives'">{{$t('okrDetailType')}}</template>
                      <template v-if="targetType === 'keyresults'">{{$t('keyResultDetailType')}}</template>
                    </span>
                    <span class="info-right">{{$t('createDateString')}} : {{targetItem.createdAt |  preparedTime}}</span>
                  </template>
                  <template v-else-if="this.targetType.match(/1on1s/)">
                    <span class="info-menu flex-box">
                      <template v-if="targetOneItem.contents">{{$t('retrospectiveStr').replace('{$date}', targetOneItem.date)}}</template>
                    </span>
                    <span class="info-right">
                    </span>
                  </template>
                  <!-- <template v-else-if="targetType === '1on1requests'">
                    <span class="info-menu flex-box">{{$t('oneOnRequestListTileType')}}</span>
                    <span class="info-right"></span>
                  </template> -->
                  <template v-else-if="targetType === 'rtfbs'">
                    <span class="info-menu flex-box">{{$t('rtfbType')}}</span>
                    <span class="info-right">
                      <span class="info-time">{{ this.targetFeed.createdAt | preparedTime }}</span>
                    </span>
                  </template>
                </div>
                <div v-if="targetType === 'objectives' || targetType === 'keyresults'">
                  <div class="ibox-title detail-head">
                    <objective :detailView="true" :itemId="this.targetItemKey" :content="targetItem.contentText" :progress="targetItem.progress ? targetItem.progress : '0'" :setReadOnly="'true'" v-on:set-progress="updateProgressInfo" :objective="false"/>
                    <span class="due-date due-date-color">{{$t('dueDateStr')}} : {{targetItem.dueDate}}</span>
                  </div>
                  <div class="ibox-child public-wrap">
                    <div class="row">
                      <div class="form-group col-sm-12 info-status public-detail-status">
                        <div class="public-detail">
                          <div>
                            <label class="control-label status-label" for="status">{{$t('sharedOwnersStr')}}</label>
                          </div>
                        </div>
                        <div v-if="targetItem && targetItem.sharedOwners" class="public-box">
                          <ul>
                            <li v-for="owner in getTargetSharedOwners" :key="owner.id" class="public-cell">
                              <span class="public-userimg">
                                <img v-if="owner.userInfo.userIcon" :src="owner.userInfo.userIcon" alt="image" class="img-circle">
                                <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                              </span>
                              <div class="public-userinfo">
                                <span class="public-username">{{owner.userInfo.userName}}</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ibox-child public-wrap">
                    <div class="row">
                      <div class="form-group col-sm-12 info-status public-detail-status">
                        <div class="public-detail">
                          <div class="">
                            <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                            <span v-if="!targetItem.limitedAccess">{{$t('allPeopleStrType')}}</span>
                            <span v-else-if="targetItem.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                            <span v-else-if="targetItem.limitedAccess.limitedGroup">{{$t('peopleGroupTileType')}}</span>
                          </div>
                        </div>
                        <div v-if="targetItem.limitedAccess" class="public-box">
                          <div v-if="targetItem.limitedAccess.limitedUsers">
                            <ul>
                              <li v-for="limited in getTargetLimitedAccess(targetItem)" :key="limited.id" class="public-cell">
                                <span class="public-userimg">
                                  <img alt="image" v-if="limited.userInfo.userIcon" class="img-circle" :src="limited.userInfo.userIcon" />
                                  <img alt="image" v-else class="img-circle"  :src="'static/img/noImage.png'" />
                                </span>
                                <div class="public-userinfo"><span class="public-username">{{limited.userInfo.userName}}</span></div>
                              </li>
                            </ul>
                          </div>
                          <div v-else-if="targetItem.limitedAccess.limitedGroup" class="public-detail-group">
                            <ul><li><span class="public-username">{{(getTargetLimitedAccess(targetItem)[targetItem.limitedAccess.limitedGroup]||{}).groupName||'** Group is removed. **'}}</span></li></ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ib-sub-content">
                    <b-tabs>
                      <b-tab @click="showCommentForm" :title="$t('commentLabelTitle')">
                        <div class="tab-pane">
                          <div class="panel-body">
                            <div v-if="!getTargetComments" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotCommentStr')}}</span></div>
                            <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                              <comment-item @set-reply="setParentCommentId" :propComment="obj" :isClickedComment="clickedCommentId === obj.id" :clickedCommentId="clickedCommentId"/>
                            </div>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab @click="notShowCommentForm" :title="$t('relatedOkrType')">
                        <div class="tab-pane">
                          <div class="panel-body">
                            <div v-for="obj in this.targetItem.relations" :key="obj.id" v-if="obj.type" class="ibox-child">
                              <relation-item :itemId="obj.key" :userId="obj.userId" :type="obj.type" v-on:get-detail="getDetail"/>
                            </div>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
                <div v-else-if="targetType.match(/1on1s/)">
                  <!-- 1on1-detail1 -->
                  <div id="one-detail1" class="ibox">
                    <div class="ibox-title detail-head">
                      <div class="flex-box cursor">
                        <img v-if="targetOneContent === 0" class="one-icon" :src="'static/img/1on1/img0' + 1 + '.png'" alt="">
                        <img  v-else-if="targetOneContent === 1" class="one-icon" :src="'static/img/1on1/img0'+ 2 +'.png'" alt="">
                        <img v-else-if="targetOneContent === 2" class="one-icon" :src="'static/img/1on1/img0' + 3 + '.png'" alt="">
                        <img v-else class="one-icon" src="static/img/1on1/img05.png" alt="">
                        <div class="comment">
                          <template v-if="targetOneContent === 0">
                            <h4 class="h3">{{$t('firstContent1on1')}}</h4>
                            <read-more :text="this.targetOneItem.contents[0]" :targetId="this.targetOneItemKey + '_0'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{this.targetOneItem.contents[0]}} </read-more>
                          </template>
                          <template v-else-if="targetOneContent === 1">
                            <h4 class="h3">{{$t('secondContent1on1')}}</h4>
                            <read-more :text="this.targetOneItem.contents[1]" :targetId="this.targetOneItemKey + '_1'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{this.targetOneItem.contents[1]}} </read-more>
                          </template>
                          <template v-else-if="targetOneContent === 2">
                            <h4 class="h3">{{$t('thirdContent1on1')}}</h4>
                            <read-more :text="this.targetOneItem.contents[2]" :targetId="this.targetOneItemKey + '_2'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{this.targetOneItem.contents[2]}} </read-more>
                          </template>
                          <template v-else-if="targetOneContent === 3">
                            <h4 class="h3">{{$t('fiveContent1on1')}}</h4>
                            <read-more :text="this.targetOneItem.contents[3]" :targetId="this.targetOneItemKey + '_3'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{this.targetOneItem.contents[3]}} </read-more>
                          </template>
                          <template v-else>
                            <h4 class="h3">{{$t('memoContent1on1')}}</h4>
                            <read-more :text="this.targetOneItem.memo" :targetId="this.targetOneItemKey + '_memo'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{this.targetOneItem.memo}} </read-more>
                          </template>
                        </div>
                      </div>
                    </div>
                    
                    <!-- public -->
                    <div class="ibox-child public-wrap">
                      <div class="row">
                        <div class="form-group col-sm-12 info-status public-detail-status">
                          <div class="public-detail">
                            <div>
                              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                              <span v-if="!this.targetOneItem.limitedAccess">{{$t('allPeopleStrType')}}</span>
                              <span v-else-if="this.targetOneItem.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                              <span v-else-if="this.targetOneItem.limitedAccess.limitedGroup">{{$t('peopleGroupTileType')}}</span>
                            </div>
                          </div>
                          <div v-if="this.targetOneItem.limitedAccess" class="public-box">
                            <div v-if="this.targetOneItem.limitedAccess.limitedUsers">
                              <ul>
                                <li v-for="limited in getTargetLimitedAccess(this.targetOneItem)" :key="limited.id" class="public-cell">
                                  <span class="public-userimg">
                                    <img v-if="limited.userInfo.userIcon" :src="limited.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="public-userinfo"> <span class="public-username">{{limited.userInfo.userName}}</span> </div>
                                </li>
                              </ul>
                            </div>
                            <div v-else-if="this.targetOneItem.limitedAccess.limitedGroup" class="public-detail-group">
                              <ul>
                                <li><span class="public-username">{{(getTargetLimitedAccess(this.targetOneItem)[this.targetOneItem.limitedAccess.limitedGroup]||{}).groupName||'** Group is removed. **'}}</span></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- public -->
                    <div v-if="this.targetType !== '1on1s_memo'" class="ib-sub-content">
                      <b-tabs>
                        <b-tab :title="$t('commentLabelTitle')">
                          <div class="panel-body">
                            <!-- コメント -->
                            <div v-if="!getTargetComments[0]" class="comment-view ibox-child">{{$t('stillNotCommentStr')}}</div>
                            <div v-else class="one-comment-view">
                              <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                                <comment-item @set-reply="setParentCommentId" :propComment="obj" :isClickedComment="clickedCommentId === obj.id" :clickedCommentId="clickedCommentId"/>
                              </div>
                            </div>
                            <!-- /コメント -->
                          </div>
                        </b-tab>
                        <b-tab :title="$t('niceBtnTitle')" @click="notShowCommentForm">
                          <div v-if="!this.targetOneItem || !this.targetOneItem['likes'] || !this.targetOneItem['likes'][targetOneContent]" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotLikesStr')}}</span></div>
                          <div v-else class="comment-view">
                            <div v-for="(value, key) in targetOneItem['likes'][targetOneContent]" :key="value.id"  class="ibox-child">
                              <template v-if="targetOneItem['likes'][targetOneContent]">
                                <router-link :to="{ name: 'User', params: { userId: key  }}">
                                  <div class="cursor">
                                    <span class="search-userimg">
                                      <img v-if="getUserInfoById(key).userIcon" :src="getUserInfoById(key).userIcon" alt="image" class="img-circle">
                                      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                    </span>
                                    <div class="search-userinfo">
                                      <span class="search-username">{{ getUserInfoById(key).userName }}</span>
                                      <span class="search-userdept">{{ getUserInfoById(key).dept }}</span>
                                    </div>
                                  </div>
                                </router-link>
                              </template>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                    <!-- /ib-sub-content -->
                  </div>
                  <!-- /1on1-detail -->
                </div>
                <div v-else-if="targetType === 'rtfbs'">
                  <div id="fb-detail1" class="ibox">
                    <div ref="detail" class="ibox-title detail-head cursor">
                      <div class="flex-box">
                        <span class="info-userimg">
                          <img v-if="targetUserIcon" :src="targetUserIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="comment">
                          <div class="info-userelement">
                            <a href="#">
                              <span class="info-username">{{ targetUserName }}</span>
                            </a>
                            <span class="info-time">
                              <!-- {{ this.getTargetFeed.createdAt | preparedTime }} -->
                            </span>
                          </div>
                          <span class="comment-text">
                            <read-more :text="this.targetFeed.contentText" :targetId="this.targetFeedKey" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight" >
                              {{this.targetFeed.contentText}}
                            </read-more>
                          </span>
                          <div v-if="this.targetFeed.uploadedFile" class="image-add">
                            <div class="uploaded-images" v-viewer="{
                              button: true,
                              navbar: false,
                              title: false,
                              toolbar: false,
                              tooltip: false,
                              movable: true,
                              zoomable: true,
                              rotatable: true,
                              scalable: false,
                              transition: true,
                              fullscreen: true,
                              keyboard: false }" @click.stop>
                              <img :src="this.targetFeed.uploadedFile">
                            </div>
                          </div>
                          <div class="child-tools">
                            <span class="info-menu">
                            <span class="info-comment">
                              <img src="static/img/assets/comment.png">
                              <span>{{ getCommentsByCommentIdsTargetType(this.targetFeed.comments || {},'rtfbs').length }}</span>
                            </span>
                            <a class="info-comment">
                              <img v-if="isLiked(getTargetFeed)" :src="'static/img/assets/nice_on.png'">
                              <img v-else :src="'static/img/assets/nice_off.png'">
                              <span class="like-counter" v-if="targetFeed.likes"><strong>{{ targetFeed.likes ? Object.keys(targetFeed.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                            </a>
                          </span>
                          <!-- <span class="info-right">
                            <fb-drop-down v-if="getUserId == getTargetFeed.userId" :item="getTargetFeed" :id="getTargetFeedKey"/>
                          </span> -->
                        </div>
                        </div>
                      </div>
                    </div>
                    <!-- 公開設定detail -->
                    <div class="ibox-child ublic-wrap">
                      <div class="row">
                        <div class="form-group col-sm-12 info-status public-detail-status">
                          <div class="public-detail">
                            <div>
                              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                              <span v-if="!targetFeed.limitedAccess">{{$t('allPeopleStrType')}}</span>
                              <span v-else-if="targetFeed.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                            <span v-else-if="targetFeed.limitedAccess.limitedGroup">{{$t('peopleGroupTileType')}}</span>
                            </div>
                          </div>
                          <div v-if="targetFeed.limitedAccess" class="public-box">
                            <div v-if="targetFeed.limitedAccess.limitedUsers">
                              <ul>
                                <li v-for="limited in getTargetLimitedAccess(targetFeed)" :key="limited.id" class="public-cell">
                                  <!-- {{limited}} -->
                                  <span class="public-userimg">
                                    <img v-if="limited.userInfo.userIcon" :src="limited.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="public-userinfo">
                                    <span class="public-username">{{limited.userInfo.userName}}</span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div v-else-if="targetFeed.limitedAccess.limitedGroup" class="public-detail-group">
                              <ul><li><span class="public-username">{{(getTargetLimitedAccess(targetFeed)[targetFeed.limitedAccess.limitedGroup]||{}).groupName||'** Group is removed. **'}}</span></li></ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /公開設定detail -->
                    <div class="ib-sub-content">
                      <b-tabs>
                        <b-tab :title="$t('commentLabelTitle')" @click="showCommentForm">
                          <div v-if="!getTargetComments[0]"  class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotCommentStr')}}</span></div>
                          <div v-else class="comment-view">
                            <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                              <comment-item @set-reply="setParentCommentId" :propComment="obj" :isClickedComment="clickedCommentId === obj.id" :clickedCommentId="clickedCommentId"/>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab :title="$t('niceBtnTitle')" @click="notShowCommentForm">
                          <div v-if="!this.getTargetFeed.likes" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotLikesStr')}}</span></div>
                          <div v-else class="comment-view">
                            <div v-for="(value, key) in getTargetFeed.likes" :key="value.id" v-if="getTargetFeed.likes" class="ibox-child">
                              <router-link :to="{ name: 'User', params: { userId: key, item: getCommentTargetItem() }}">
                                <div class="cursor">
                                  <span class="search-userimg">
                                    <img v-if="getUserInfoById(key).userIcon" :src="getUserInfoById(key).userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="search-userinfo">
                                    <span class="search-username">{{ getUserInfoById(key).userName }}</span>
                                    <span class="search-userdept">{{ getUserInfoById(key).dept }}</span>
                                  </div>
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                    <!-- /ibox-child -->
                  </div>
                </div>
                <div v-else-if="targetType === 'comments'">
                  <div id="fb-detail1" class="ibox">
                    <div class="ibox-title detail-head">
                      <div class="flex-box">
                        <comment-item :propComment="this.targetComment"/>
                      </div>
                    </div>
                    <!-- /ibox-child -->
                  </div>
                </div>
              </div>
            </section>
            <article v-if="isShowCommentForm" class="sub-column-comment sub-column-active">
              <section>
                <comment-form @close-event="open = false" ref="setReply" :parentItem="replyParent" :targetId="getTargetKey" :target="targetType" :userId="clickedCommentId.length > 0 ? targetOwner : userId" :targetOwner="targetOwner"/>
              </section>
            </article>
          </article>
        </div>
      </manage-wrapper-component>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {storage, willysm} from '@/main'
import CommonJs from '@/js/common'
import ProfileDropDown from '@/components/User/ProfileDropDown'
import ManageOtherItems from '@/components/Manage/ManageOtherItems'
import CommentItem from '@/components/Comment/CommentItemInManage'
import RelationItem from '@/components/Okr/RelationItem'
import CommentForm from '@/components/Comment/CommentForm'
import Objective from '@/components/Okr/Objective'
import moment from 'moment'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'

export default {
  name: 'ManageItems',
  mixins: [CommonJs],
  // mixedins: [validationMixin],
  components: {
    ProfileDropDown,
    ManageOtherItems,
    CommentForm,
    RelationItem,
    Objective,
    CommentItem,
    ReadMore,
    ManageWrapperComponent
  },
  // store,
  data: function () {
    return {
      tag: 'progress',
      // edit: false,
      userInfo: {
        userName: '',
        dept: '',
        userIcon: '',
        userFeeling: '',
        userBio: '',
        userEmail: '',
        userPhone: '',
        careerSummary: ''
      },
      clickedCommentId: '',
      carrerShowMore: false,
      carrerContentHeight: 0,
      open: false,
      userId: '',
      willysmEnabled: willysm.enabled,
      willysm: willysm,
      willysmImage: 'static/img/extApps/willysm/' + willysm.image,
      editInfo: {
        userName: '',
        dept: '',
        userFeeling: '',
        userBio: '',
        userEmail: '',
        userPhone: '',
        careerSummary: ''
      },
      uploadImage: '',
      cropImage: '',
      myCroppa: {},
      // objective
      targetItem: {
        progress: '0',
        contentText: '',
        createdAt: '',
        dueDate: '',
        limitedAccess: {},
        relations: {}
      },
      targetType: '',
      targetItemProgress: '0',
      targetItemKey: '',
      targetKeyresults: {},
      // 1on1
      targetOneItem: {},
      targetOneItemKey: '',
      targetOneContent: 0,
      targetLikes: {},
      // feedback
      feedItems: {},
      detail: {},
      targetFeed: {},
      targetFeedKey: '',
      // targetType: 'rtfbs',
      targetUserId: '',
      targetUserName: '',
      targetUserIcon: '',
      targetContent: '',
      targetComment: {},
      targetCommentKey: '',
      // target1on1Request: {},
      // target1on1RequestKey: '',
      replyParent: {},
      isShowCommentForm: true,
      manageInfo: null,
      propContentHeight: 0,
      propShowMore: false,
      targetOwner: '',
      commentTarget: '',
      targetTypeString: {
        objectives: this.$t('topTitle'),
        ones: this.$t('oneOnTileType'),
        // '1on1requests': this.$t(''),
        rtfbs: this.$t('rtfbType')
      }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageItems'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('comments/', [
      'getComments',
      'getCommentsByItemId',
      'getChildCommentsByParentId',
      'getCommentsByCommentIdsTargetType'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUserById',
      'getUserInfoById'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('rtfbs/', [
      'getRtfbsByUserId',
      'getRtfbs'
    ]),
    ...mapGetters('ones/', [
      'get1on1sByUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId',
      'getKeyresultById',
      'getKeyresultsByUserId'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsManager'
    ]),
    isManager: function () {
      return this.getMetaIsManager
    },
    getTargetComments () {
      if (this.targetType === 'objectives' || this.targetType === 'keyresults') {
        return this.getCommentsByCommentIdsTargetType(this.targetItem.comments || {}, this.targetType)
      } else if (this.targetType.match(/1on1s/)) {
        return this.getCommentsByCommentIdsTargetType(this.targetOneItem.comments || {}, this.targetType)
      } else if (this.targetType === 'rtfbs') {
        return this.getCommentsByCommentIdsTargetType(this.targetFeed.comments || {}, this.targetType)
      } else {
        return {}
      }
    },
    getTargetUserInfo () {
      if (this.userId) {
        return this.getUsersByIds([this.userId])[this.userId].userInfo
      } else {
        return {}
      }
    },
    getRelationLength () {
      return this.targetItem.relations ? Object.keys(this.targetItem.relations).length : 0
    },
    getTargetKey () {
      if (this.targetType === 'objectives' || this.targetType === 'keyresults') {
        return this.targetItemKey
      } else if (this.targetType.match(/1on1s/)) {
        return this.targetOneItemKey
      } else if (this.targetType === 'rtfbs') {
        return this.targetFeedKey
      }
    },
    getTargetFeed () {
      return this.getRtfbs[this.targetFeedKey] ? this.getRtfbs[this.targetFeedKey] : {}
    },
    getTargetFeedKey () {
      return this.targetFeedKey
    },
    getTargetTypeString () {
      if (this.targetType === 'objectives' || this.targetType === 'keyresults') {
        return this.targetTypeString['objectives']
      } else if (this.targetType.match(/1on1s/)) {
        return this.targetTypeString['ones']
      } else if (this.targetType === 'rtfbs') {
        return this.targetTypeString['rtfbs']
      // } else if (this.targetType === '1on1requests') {
      //   return this.targetTypeString['1on1requests']
      } else {
        return ''
      }
    },
    getTargetSharedOwners () {
      return this.getUsersByIds(Object.keys(this.targetItem.sharedOwners).filter(userId => userId !== this.userId))
    }
  },
  created: function () {
    console.log('ManageItems:created', this.$route.params.userId)
    if (!this.$route.params.userId) {
      console.log('this.$route.push({ name: ManageUserSearch })')
      this.$router.push({ name: 'ManageUserSearch' })
      return false
    }
  },
  mounted: function () {
    console.log(this.$route.params)
    console.log(this.$route.params.userId)
    if (this.$route.params.userId) {
      this.userId = this.$route.params.userId
      console.log('this.$route.params.userId', this.$route.params.userId)
      this.setVisit(this.userId)
      const userId = this.userId
      const user = this.getUsersByIds([userId])
      if (user) {
        console.log('user', user)
        this.userInfo.userName = user[userId].userInfo.userName
        this.userInfo.dept = user[userId].userInfo.dept
        if (user[userId].userInfo.userIcon) {
          this.userInfo.userIcon = user[userId].userInfo.userIcon
        }
        this.userInfo.userFeeling = user[userId].userInfo.userFeeling
        this.userInfo.userBio = user[userId].userInfo.userBio
        this.userInfo.userEmail = user[userId].userInfo.userEmail
        this.userInfo.userPhone = user[userId].userInfo.userPhone
        this.userInfo.careerSummary = user[userId].userInfo.careerSummary
        if (this.$route.params.item) {
          const $t = this.$t
          let key = Object.keys(this.$route.params.item)
          let value = Object.values(this.$route.params.item)
          if (key[0] === 'objectives') {
            const currentObjectives = this.getObjectivesByUserId(this.userId, true)
            if (currentObjectives[value[0]]) {
              this.targetType = 'objectives'
              this.targetItem = currentObjectives[value[0]]
              this.targetItemKey = value[0]
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('deletedObjective'),
                type: 'warning'
              })
            }
          } else if (key[0] === 'keyresults') {
            const currentKeyresults = this.getKeyresultsByUserId(this.userId, true)
            console.log('currentKeyresults', currentKeyresults)
            if (currentKeyresults[value[0]]) {
              console.log('currentKeyresults[value]', currentKeyresults)
              this.targetType = 'keyresults'
              this.targetItem = currentKeyresults[value[0]]
              this.targetItemKey = value[0]
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('keyResultDeleted'),
                type: 'warning'
              })
            }
          } else if (key[0] === '1on1s') {
            const current1on1s = this.get1on1sByUserId(this.userId, true)
            if (current1on1s[value[0]]) {
              console.log('current1on1s[value]', current1on1s[value[0]])
              this.targetOneItem = current1on1s[value[0]]
              this.targetOneItemKey = value[0]
              this.targetOneContent = '0'
              this.targetType = '1on1s_0'
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('beenDeleted'),
                type: 'warning'
              })
            }
          } else if (key[0] === 'rtfbs') {
            const currentRtfbs = this.getRtfbsByUserId(this.userId, true)
            let targetFeedItem = currentRtfbs.filter(x => x.key === value[0])
            if (targetFeedItem.length > 0) {
              this.targetFeed = targetFeedItem[0].feed
              this.targetFeedKey = value[0]
              this.targetUserName = this.getUsersByIds(value[0]).userName
              if (this.getUsersByIds(value[0]).userIcon) {
                this.targetUserIcon = this.getUsersByIds(value[0]).userIcon
              }
              this.targetType = 'rtfbs'
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('fbDeleted'),
                type: 'warning'
              })
            }
          }
          // this.open = true
        } else if (this.$route.params.itemId) {
          const $t = this.$t
          if (this.$route.params.type === 'objectives') {
            const currentObjectives = this.getObjectivesByUserId(this.userId, true)
            if (currentObjectives[this.$route.params.itemId]) {
              this.targetType = 'objectives'
              this.targetItem = currentObjectives[this.$route.params.itemId]
              this.targetItemKey = this.$route.params.itemId
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('deletedObjective'),
                type: 'warning'
              })
            }
          } else if (this.$route.params.type === 'keyresults') {
            const currentKeyresults = this.getKeyresultsByUserId(this.userId, true)
            console.log(this.$route.params.itemId)
            if (currentKeyresults[this.$route.params.itemId]) {
              this.targetType = 'keyresults'
              this.targetItem = currentKeyresults[this.$route.params.itemId]
              this.targetItemKey = this.$route.params.itemId
              this.open = true
            } else {
              this.$swal({
                title: $t('popTitleStrType'),
                text: $t('keyResultDeleted'),
                type: 'warning'
              })
            }
          }
          // this.open = true
        }
      }
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    const userId = to.params.userId
    const user = this.getUsersByIds(userId)
    this.userInfo.userName = user[userId].userInfo.userName
    this.userInfo.dept = user[userId].userInfo.dept
    this.userInfo.userIcon = user[userId].userInfo.userIcon
    this.userInfo.userFeeling = user[userId].userInfo.userFeeling
    this.userInfo.userBio = user[userId].userInfo.userBio
    this.userInfo.userEmail = user[userId].userInfo.userEmail
    this.userInfo.userPhone = user[userId].userInfo.userPhone
    this.userInfo.careerSummary = user[userId].userInfo.careerSummary
    if (to.params.itemId) {
      if (to.params.type === 'objectives') {
        const currentObjectives = this.getObjectivesByUserId(this.userId, true)
        if (currentObjectives[to.params.itemId]) {
          this.targetType = 'objectives'
          this.targetItem = currentObjectives[to.params.itemId]
          this.targetItemKey = to.params.itemId
        }
      } else if (to.params.type === 'keyresults') {
        const currentKeyresults = this.getKeyresultById(to.params.itemId, this.userId, true)
        console.log('currentKeyresults', currentKeyresults)
        if (currentKeyresults) {
          console.log('currentKeyresults[value]', currentKeyresults)
          this.targetType = 'keyresults'
          this.targetItem = currentKeyresults
          this.targetItemKey = to.params.itemId
        }
      }
    }
    next()
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('comments', {
      removeComment: 'REMOVE_COMMENT'
    }),
    ...mapActions('rtfbs/', {
      // VuexFireからのActionを読み込み
      setLikes: 'SET_LIKES',
      removeLikes: 'REMOVE_LIKES'
    }),
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateProgressInfo: function (value) {
      console.log('hoge')
    },
    getTargetLimitedAccess (item) {
      console.log('item.limitedAccess', item)
      if (!item.limitedAccess) {
        return {}
      } else if (item.limitedAccess.limitedUsers) {
        return this.getUsersByIds(Object.keys(item.limitedAccess.limitedUsers))
      } else if (item.limitedAccess.limitedGroup) {
        return this.getGroupsByIds([item.limitedAccess.limitedGroup])
      }
    },
    setTarget: function (value) {
      this.clickedCommentId = ''
      this.manageInfo = null
      if (value.targetType === 'objectives' || value.targetType === 'keyresults') {
        this.targetType = value.targetType
        this.targetItem = value.targetItem
        this.targetItemKey = value.targetItemKey
      } else if (value.targetType.match(/1on1s/)) {
        this.targetOneItem = value.targetOneItem
        this.targetOneItemKey = value.targetOneItemKey
        this.targetOneContent = value.targetContent === 'memo' ? 'memo' : Number(value.targetContent)
        this.targetType = value.targetType
        this.targetLikes = value.targetLikes
      } else if (value.targetType === 'rtfbs') {
        this.targetFeed = value.targetFeed
        this.targetFeedKey = value.targetFeedKey
        this.targetUserName = value.targetUserName
        this.targetUserIcon = value.targetUserIcon
        this.targetType = value.targetType
      }
      this.clickedCommentId = value.commentId
      if (value.targetOwner) {
        this.targetOwner = value.targetOwner
        this.manageInfo = this.getUserInfoById(value.targetOwner)
        this.commentTarget = value.targetOwner
        console.log('ManageItemuserinfo', this.getUserInfoById(value.targetOwner))
      }
      console.log(value)
      this.open = true
    },
    setEdit: function () {
      // 編集中データをセット
      this.editInfo = {
        userName: this.userInfo.userName,
        dept: this.userInfo.dept,
        userFeeling: this.userInfo.userFeeling,
        userBio: this.userInfo.userBio,
        userEmail: this.userInfo.userEmail,
        userPhone: this.userInfo.userPhone,
        careerSummary: this.userInfo.careerSummary
      }
      if (this.userInfo.userIcon) {
        this.editInfo.userIcon = this.userInfo.userIcon
      }
      console.log(this.editInfo)
      this.edit = !this.edit
    },
    updateFeeling: function (value) {
      // コンディションの変更
      if (this.edit) {
        this.editInfo.userFeeling = value
      } else {
        this.setFeeling(value)
      }
    },
    // プロフィール画像プロップ処理
    onFileTypeMismatch (file) {
      const $t = this.$t
      this.swal({
        text: $t('orderFileUploadStr'),
        type: 'waning'
      })
      // alert('jpg, gif, png形式でアップして下さい。')
    },
    onFileSizeExceed (file) {
      const $t = this.$t
      this.$swal({
        text: $t('order2mbFileStr'),
        type: 'warning'
      })
      // alert('ファイルは2mb以下でアップロードして下さい。')
    },
    uploadResizedPhoto () {
      var date = moment()
      var profileImageUrl = date.format('1+YYYY/MM/DD HH:mm') + '.jpg'
      const storageProfilePhotoRef = storage.ref('profilepictures')
      const path = profileImageUrl
      const photoImagesRef = storageProfilePhotoRef.child(path)
      this.myCroppa.generateBlob((blob) => {
        photoImagesRef.put(blob)
          .then((snapshot) => {
            const photoURL = snapshot.downloadURL
            this.editInfo.userIcon = photoURL
          })
          .catch((err) => {
            console.log('upload error:', err)
          })
      })
    },
    updateProfile: function () {
      // プロフィール更新処理
      if (this.$v.editInfo.userName.nameValidation) {
        this.setProfile(this.editInfo)
        this.edit = !this.edit
      }
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    setParentCommentId: function (value) {
      this.replyParent = value
      this.$refs.setReply.setContentTextByParent(value.item, value.id)
    },
    getDetail: function (value) {
      console.log('objective value', value)
      this.userId = value.userId
      this.$router.push({ name: 'User', params: { userId: value.userId, type: value.type, itemId: value.itemId } })
    },
    showCommentForm () {
      this.isShowCommentForm = true
    },
    notShowCommentForm () {
      this.isShowCommentForm = false
    },
    sendDeleteRequest: function (type, userId, itemId, content) {
      const censorText = this.$firebase.functions().httpsCallable('censorText')
      console.log('type, userId, itemId, content', type, userId, itemId, content)
      return censorText({
        type: type,
        userId: userId,
        itemId: itemId,
        content: content
      }).then(res => {
        console.log('deleteResponse: ', res)
      }).catch(err => {
        console.log('deleteResponseError: ', err)
      })
    },
    getCommentTargetItem: function () {
      let item = {}
      item[this.targetType] = this.getTargetKey
      item.type = this.targetType
      return item
    },
    onClickDeleteButton () {
      const $t = this.$t
      this.$swal({
        title: 'プロフィール削除',
        text: 'どの要素を削除しますか？',
        type: 'question',
        input: 'select',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        inputOptions: {
          userName: $t('profileUserTitle'),
          dept: $t('departmentStr'),
          userBio: $t('profileBioTitle'),
          careerSummary: $t('profileSummaryTitle')
        }
      }).then((result) => {
        if (result.value) {
          this.sendDeleteRequest('profile', this.userId, null, result.value).then(
            this.$swal({
              title: this.$t('compDeleteStr'),
              type: 'success'
            })
          )
        } else {
          console.log('confirmDeletePictureStr -> false')
        }
      })
    },
    onClickDeleteItem () {
      let targetType = this.targetType
      let content = 'contentText'
      if (this.clickedCommentId.length > 0) {
        targetType = 'comments'
      } else if (this.targetType.match(/1on1s/)) {
        targetType = this.targetType.split('_')[0]
        content = this.targetOneContent
      }
      console.log('itemId', this.targetType, targetType, this.targetItemKey)
      let itemId = this.getItemIdByType(targetType)
      console.log('targetType, this.userId, itemId, content::::::::', targetType, this.userId, itemId, content)
      this.$swal({
        title: this.$t('doDeleteStr'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false
      }).then((result) => {
        if (result.value) {
          if (targetType === 'comments') {
            console.log('ManageItems:onClickDeleteItem')
            this.commentDelete(this.getComments[this.clickedCommentid]).then(
              this.$swal({
                title: this.$t('compDeleteStr'),
                type: 'success'
              })
            )
          } else {
            this.sendDeleteRequest(targetType, this.userId, itemId, content).then(
              this.$swal({
                title: this.$t('compDeleteStr'),
                type: 'success'
              })
            )
          }
        } else {
          console.log('confirmDeletePictureStr -> false')
        }
      })
    },
    commentDelete: function (comment) {
      let deleteInfo = {}
      if (this.getChildCommentsByParentId(comment.id, comment.target).length > 0) {
        deleteInfo = {
          parentId: 'parent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId
        }
      } else {
        deleteInfo = {
          parentId: 'notParent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId
        }
      }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      deleteInfo.byManager = true
      console.log('ManageItems:commentDelete', deleteInfo)
      this.removeComment(deleteInfo)
    },
    getItemIdByType: function (type) {
      let itemId
      switch (type) {
        case 'objectives':
        case 'keyresults':
          itemId = this.targetItemKey
          break
        case '1on1s':
          itemId = this.targetOneItemKey
          break
        case 'rtfbs':
          itemId = this.targetFeedKey
          break
        // case '1on1requests':
        //   itemId = this.target1on1RequestKey
        //   break
        case 'comments':
          itemId = this.clickedCommentId
          break
        default:
          itemId = ''
          break
      }
      console.log('itemid', itemId)
      return itemId
    },
    updateCarrerShowMore: function (value) {
      this.carrerShowMore = value
    },
    updateCarrerContentHeight: function (value) {
      this.carrerContentHeight = value
    },
    isLiked: function (feed) {
      if (!feed.likes) {
        return false
      } else {
        return Object.keys(feed.likes).filter(x => x === this.getUserId).length !== 0
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#manage-wrapper .manage-table {
  height: calc(100% - 10.5vh)
}
.willysmForm {
width: 27%;
}
.willysmImage {
  display: unset;
  width: 95%;
  min-width: 95%;
  position: relative;
  top: 12px;
  right:-5px;
  cursor: pointer;
  cursor: hand;
}
.willysm {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageItems.vue